/**
 * @generated SignedSource<<a054fdbb71ff2ae23af8a6ce892faead>>
 * @relayHash c5e65ec095a24706c14249e2fa660305
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe0eb290612d04afb3cb58772da417705764ec181d5eed1f05b1c8754d22ded7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraJqlScopeInput = {
  backlog?: JiraJqlBacklogInput | null | undefined;
  board?: JiraJqlBoardInput | null | undefined;
  list?: JiraIssueSearchScope | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
  project?: JiraJqlProjectInput | null | undefined;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type JiraJqlProjectInput = {
  projectKey?: string | null | undefined;
};
export type JiraHydrateJqlInput = {
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  lastUsedJqlForIssueNavigator?: JiraJqlScopeInput | null | undefined;
  viewQueryInput?: JiraIssueSearchViewQueryInput | null | undefined;
};
export type JiraIssueSearchViewQueryInput = {
  projectKeyAndItemIdQuery?: JiraIssueSearchViewProjectKeyAndItemIdQuery | null | undefined;
  viewAri?: string | null | undefined;
};
export type JiraIssueSearchViewProjectKeyAndItemIdQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type FilterPopupContentEntryPointQuery_hydrateQuery$variables = {
  accountId: string;
  cloudId: string;
  filterAri: string;
  includeJira: boolean;
  includeUser: boolean;
  input?: JiraHydrateJqlInput | null | undefined;
  isFilter: boolean;
  isPlanReleaseFeatureToggleEnabled: boolean;
  jql?: string | null | undefined;
  scope?: JiraJqlScopeInput | null | undefined;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type FilterPopupContentEntryPointQuery_hydrateQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FilterPopupContentEntryPoint_hydrate">;
};
export type FilterPopupContentEntryPointQuery_hydrateQuery = {
  response: FilterPopupContentEntryPointQuery_hydrateQuery$data;
  variables: FilterPopupContentEntryPointQuery_hydrateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeJira"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeUser"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFilter"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPlanReleaseFeatureToggleEnabled"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v11 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v12 = {
  "kind": "Variable",
  "name": "viewContext",
  "variableName": "viewContext"
},
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v15 = {
  "kind": "ScalarField",
  "name": "key"
},
v16 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v17 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = [
  {
    "concreteType": "JiraStatusCategory",
    "kind": "LinkedField",
    "name": "statusCategory",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "colorName"
      },
      (v18/*: any*/)
    ]
  }
],
v20 = [
  (v13/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  (v18/*: any*/)
],
v21 = [
  (v13/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "LinkedField",
        "name": "fields",
        "plural": true,
        "selections": [
          (v13/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v14/*: any*/),
              {
                "concreteType": "JiraJqlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "operators"
                  },
                  {
                    "concreteType": "JiraJqlSearchTemplate",
                    "kind": "LinkedField",
                    "name": "searchTemplate",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  (v16/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "shouldShowInContext"
                  },
                  {
                    "condition": "isPlanReleaseFeatureToggleEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          (v11/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "shouldExcludeInScope"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "concreteType": "JiraFieldType",
                    "kind": "LinkedField",
                    "name": "fieldType",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              {
                                "concreteType": "JiraJqlCascadingOptionFieldValue",
                                "kind": "LinkedField",
                                "name": "parentOption",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v14/*: any*/),
                                  (v17/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlCascadingOptionFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "small"
                                      }
                                    ]
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlProjectFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "JiraJqlStatusFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "JiraJqlStatusCategoryFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "xsmall"
                                      }
                                    ]
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueTypeFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v20/*: any*/)
                              }
                            ],
                            "type": "JiraJqlUserFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlPriorityFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "text"
                                                  }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              (v18/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "state"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "boardName"
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlSprintFieldValue"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedValue"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "error",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedError"
                  }
                ]
              }
            ],
            "type": "JiraJqlQueryHydratedField"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "jql"
      }
    ],
    "type": "JiraJqlHydratedQuery"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ],
    "type": "QueryError"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FilterPopupContentEntryPointQuery_hydrateQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "FilterPopupContentEntryPoint_hydrate"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "FilterPopupContentEntryPointQuery_hydrateQuery",
    "selections": [
      {
        "condition": "includeJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  }
                ],
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "condition": "isFilter",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                          },
                          {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "jql"
                          },
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "kind": "LinkedField",
                        "name": "hydrateJqlQuery",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "isFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "filterAri"
                          },
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "kind": "LinkedField",
                        "name": "hydrateJqlQueryForFilter",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeUser",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
              }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v20/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fe0eb290612d04afb3cb58772da417705764ec181d5eed1f05b1c8754d22ded7",
    "metadata": {},
    "name": "FilterPopupContentEntryPointQuery_hydrateQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6ff28df67a96f174a11c362100ffb9e6";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
